import { SET_PREVIEW, RESET_PREVIEW } from './actionTypes';

export const setPreview = columns => ({
  type: SET_PREVIEW,
  payload: { columns },
});

export const resetPreview = () => ({
  type: RESET_PREVIEW,
});



// WEBPACK FOOTER //
// ./src/views/ReportPreview/flow/actions.js